<template>
  <div :class="['overlay', belowNav ? 'below-nav' : 'above-nav']">
    <div class="overlay-content">
      <div v-if="this.message.split(' ').shift() !== 'Error'" class="relative">
        <div v-if="percent" class="percent">
          {{ percent }}
        </div>
        <div v-if="showSpinner" class="loader" />
      </div>
      <p class="message">
        {{ message }}
      </p>
      <p v-if="uploading" class="smallEmphasis">
        {{ uploadedinMB }}Mb of {{ totalinMB }}Mb uploaded
      </p>
      <p v-else class="smallEmphasis">
        &nbsp;
      </p>
      <button v-if="cancelButton" class="primaryButton cancelButton fixed-width" @click="cancelHandler">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    message: {
      type: String,
      required: false
    },
    belowNav: {
      type: Boolean,
      required: false,
      default: false
    },
    showSpinner: {
      type: Boolean,
      required: false,
      default: false
    },
    percent: {
      type: Number,
      required: false,
      default: 0,
    },
    uploading: {
      type: Boolean,
      required: false,
      default: false
    },
    uploadedinMB: {
      type: String,
      required: false,
      default: ''
    },
    totalinMB: {
      type: String,
      required: false,
      default: ''
    },
    cancelButton: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Cancel'
    }
  },
  methods: {
    cancelHandler() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../styles/main.styl';
  
.percent
  position: absolute
  width: 100%
  text-align: center
  top: 35px
  font-size: 2.4em
  font-weight: bold
  margin-top: 3px

.overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(255, 255, 255, .95)
  display: flex
  transition: opacity .3s ease

.overlay-content
  margin: auto !important
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  max-width: 90%;

.message
  white-space: pre-line;
  word-wrap: break-word;
  max-width: 500px;
  line-height: 1.5;

.below-nav
  z-index: $overlay-z-index--under;
  padding-left: 75px;

.above-nav
  z-index: $overlay-z-index;

// Mobile: the 75px left inset centres the overlay in the content area beside the 150px desktop
// nav rail. That rail isn't in the mobile layout (the nav is an off-canvas drawer), so the inset
// just pushes the spinner off-centre — zero it so it centres in the full viewport.
@media (max-width: mobile-breakpoint)
  .below-nav
    padding-left: 0

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  font-size: 10px;
  position: relative;
  border-top: 2px solid #color-light-grey;
  border-right: 2px solid #color-light-grey;
  border-bottom: 2px solid #color-light-grey;
  border-left: 2px solid #E95557;
  transform: translateZ(0);
  animation: load8 1.1s infinite linear;
}

@keyframes load8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
